import React,{ useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Chip from '@mui/material/Chip';
import EditIcon from '@mui/icons-material/Edit';
import Avatar from '@mui/material/Avatar';

import { getAuth, onAuthStateChanged} from 'firebase/auth';
import { db } from './../firebase-config';
import { collection, getDoc, doc, onSnapshot } from 'firebase/firestore';

import HeaderBack from './common/HeaderBack';
import Meow from './common/Meow'; 
import Nav from './common/Navigation';
import PostFeed from './common/PostFeed'; 

export default function Profile({titleHead}){
	const[dataK, setDataK] = useState({});
	
	let navigate = useNavigate();
	
	useEffect(() => {
		
		const auth = getAuth();		
		const userK = auth.currentUser;
				
			if(userK != null){
					
				const createmeow = async () => {
				
				const unsub = onSnapshot(doc(db, "users", userK.uid), (doc) => {
					setDataK(doc.data())
					});
				}
				createmeow();
				};
		
		let authToken = sessionStorage.getItem("Auth Token");
		if(authToken){
			navigate('/profile')
		}
		
		if(!authToken){
			navigate('/')
		}
	}, []);
			

	
	return(
		<>
			<HeaderBack titleHead="Profile"/>
			<Meow />
			<img className="profile-header-img" alt="infi image of a girl" src="https://source.unsplash.com/random/girl" />
			<main className="profile">
				<article className="profile-image-edit">
					<Avatar alt="Remy Sharp" src="https://source.unsplash.com/random/girl" sx={{ width: 150, height: 150 }} />
					<Chip icon={<EditIcon sx={{ width: 24, height: 24 }}/>} color="secondary" variant="outlined" label="Edit profile" onClick={() => {navigate('/editprofile')}}/>
				</article>
			
				<article className="bio">
					<h2>{dataK.name}</h2>
					<p>@{dataK.meowName}</p>
					<h4>{dataK.bio}</h4>
					<p><strong>Location</strong> {dataK.location}</p>
					<p>Website {dataK.website}</p>
				</article>
				
				<section className="profile-posts">
					<hr />
					<PostFeed />

				</section>
				<p></p>
			</main>
			<Nav />
		</>
	);
}